const config = require("appConfig")
//const config = require("config/dev")

module.exports = config
